import { render, staticRenderFns } from "./about-codex.vue?vue&type=template&id=035556aa"
import script from "./about-codex.vue?vue&type=script&lang=js"
export * from "./about-codex.vue?vue&type=script&lang=js"
import style0 from "./about-codex.vue?vue&type=style&index=0&id=035556aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports